<template>
    <transition name="modal">
        <div class="modal-mask" @click="$emit('close')">
            <div class="modal-wrapper scrollable" @click.stop>
                <div class="modal-container modal-dialog modal-resize" style="width: 95%">
                    <div class="modal-content">
                        <div>
                            <div class="col-xs-10">
                                <h5 >Print Cover</h5>
                            </div>
                            <div class="col-xs-2 text-right" style="padding-right: 10px;padding-top: 5px">
                                <button type="button" class="close" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div>

                            <div class="col-md-4 text-left" style="padding-bottom: 15px;">
                                <template v-if="profile">
                                <label for="">Your Address</label>
                                <textarea name="" id="" class="form-control" rows="5" style="resize: vertical" v-model="profile.pageaddress"></textarea>
                                <span class="small">Note* Your address is able to change in setting menu permanently</span>
                                <br>
                                <br>
                                </template>
                                <label for="">Customer Address</label>
                                <textarea name="" id="" class="form-control" rows="5" style="resize: vertical" v-model="order.nameaddress"></textarea>
                                <br>
                                <div class="text-center">
                                    <a href="javascript:void(0);" class="btn btn-primary" @click="printCover">Print</a>
                                    <a href="javascript:void(0);" class="btn btn-default" @click="$emit('close')">Close</a>
                                </div>
                                <br>
                            </div>
                            <div class="col-md-8" style="padding-bottom: 15px;">
                                <div style="background: grey;overflow: auto;border: 1px solid #eee;">
                                    <div style="width: 230mm;">
                                        <div id="printable" class="page">
                                            <div class="subpage">
                                                <div class="cover-address container-fluid">
                                                    <div class="row" >
                                                        
                                                        <div class="sender col-xs-5" >
                                                            <div class="box" style="min-height: 250px">
                                                                <strong class="title">ผู้ส่ง</strong>
                                                                <p class="address" v-if="profile">
                                                                    {{ profile.pageaddress }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div class="receiver col-xs-7" style="min-height: 400px">
                                                            <div class="box" style="min-height: 350px">

                                                                <strong class="title">ผู้รับ</strong>
                                                                <p class="address">
                                                                    {{ order.nameaddress }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div class="col-xs-12"><hr></div>
                                                        <div class="col-xs-6">
                                                            <div style="overflow:auto">
                                                                <img class="current-bot-image" :src="'https://graph.facebook.com/'+ selectedBot.pageid +'/picture?width=100&height=100'" alt="Card image cap" style="border:solid 1px #eee; border-radius: 50%;width:50px;height:50px;margin-right:5px;"> 
                                                                <h4 style="margin-top: 10px;">{{ selectedBot.pagename }}</h4>
                                                                <p class="address" v-if="profile">
                                                                    {{ profile.pageaddress }}
                                                                </p>

                                                                <hr>
                                                                <h4>{{order.first_name}} {{order.last_name}}</h4>
                                                                <p>{{ order.nameaddress }}</p>
                                                            </div>
                                                            <div class="clearfix"></div>
                                                        </div>
                                                        <div class="col-xs-6">
                                                            <h3>ใบเสร็จ/ใบส่งของ</h3>
                                                            <div class="row">
                                                                <div class="col-xs-6">วันที่สั่งซื้อ</div>
                                                                <div class="col-xs-6">{{order.timestamp | moment("DD/MM/YYYY")}}</div>
                                                                <div class="clearfix"></div>
                                                                <template  v-if="order.trackingno">
                                                                <div class="col-xs-6">Tracking No.</div>
                                                                <div class="col-xs-6">{{order.trackingno}}</div>
                                                                <div class="clearfix"></div>
                                                                </template>

                                                                <div class="col-xs-6">ช่องทางการชำระสินค้า</div>
                                                                <div class="col-xs-6">{{order.payment | capitalize}}</div>
                                                            </div>

                                                            <hr>

                                                            <strong>รายละเอียดสินค้า</strong>

                                                            
                                                            <nl2br tag="p" :text="order.productdetail" />

                                                            <hr>

                                                            <strong>ยอดชำระเงินทั้งหมด</strong>
                                                            {{order.amount | decimalFormat}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
		<!-- <div class="modal-mask" @click="$emit('close')">
			<div class="modal-wrapper" role="document" style="overflow-y:auto;position:absolute">
				<div class="modal-container modal-dialog">
					<div class="modal-content" @click.stop>
						<div class="modal-header">
							<div class="row">
								<div class="col-xs-10">
                                    Print Cover
								</div>
								<div class="col-xs-2">
								<button type="button" class="close" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">&times;</span>
								</button>
								</div>
							</div>	
						</div>
						<div class="modal-body">
                            <div id="printable">
                                <div class="cover-address container-fluid">
                                    <div class="row" >
                                         
                                        <div class="sender col-xs-5" >
                                            <div class="box" style="min-height: 250px">
                                                <strong class="title">ผู้ส่ง</strong>
                                                <p class="address" v-if="profile">
                                                    {{ profile.pageaddress }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="receiver col-xs-7" style="min-height: 400px">
                                            <div class="box" style="min-height: 350px">

                                                <strong class="title">ผู้รับ</strong>
                                                <p class="address">
                                                    {{ order.nameaddress }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-xs-12"><hr></div>
                                        <div class="col-xs-6">
                                            <div style="overflow:auto">
                                                <img class="current-bot-image" :src="'https://graph.facebook.com/'+ selectedBot.pageid +'/picture?width=100&height=100'" alt="Card image cap" style="border:solid 1px #eee; border-radius: 50%;width:50px;height:50px;margin-right:5px;"> 
                                                <h4 style="margin-top: 10px;">{{ selectedBot.pagename }}</h4>
                                                <p class="address" v-if="profile">
                                                    {{ profile.pageaddress }}
                                                </p>

                                                <hr>
                                                <h4>{{order.first_name}} {{order.last_name}}</h4>
                                                <p>{{ order.nameaddress }}</p>
                                            </div>
                                            <div class="clearfix"></div>
                                        </div>
                                        <div class="col-xs-6">
                                            <h3>ใบเสร็จ/ใบส่งของ</h3>
                                            <div class="row">
                                                <div class="col-xs-6">วันที่สั่งซื้อ</div>
                                                <div class="col-xs-6">{{order.timestamp | moment("DD/MM/YYYY")}}</div>
                                                <div class="clearfix"></div>
                                                <template  v-if="order.trackingno">
                                                <div class="col-xs-6">Tracking No.</div>
                                                <div class="col-xs-6">{{order.trackingno}}</div>
                                                <div class="clearfix"></div>
                                                </template>

                                                <div class="col-xs-6">ช่องทางการชำระสินค้า</div>
                                                <div class="col-xs-6">{{order.payment | capitalize}}</div>
                                            </div>

                                            <hr>

                                            <strong>รายละเอียดสินค้า</strong>

                                            
                                            <nl2br tag="p" :text="order.productdetail" />

                                            <hr>

                                            <strong>ยอดชำระเงินทั้งหมด</strong>
                                            {{order.amount | decimalFormat}}
                                        </div>
                                    </div>
                                </div>
                            </div>
						</div>

                        <div class="modal-footer">
                            <a href="javascript:void(0);" class="btn btn-primary" @click="printCover">Print</a>
                            <a href="javascript:void(0);" class="btn btn-default" @click="$emit('close')">Close</a>
                        </div>
					</div>
				</div>
			</div>
		</div> -->
    </transition>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Nl2br from 'vue-nl2br'
import config from '@/config'
import api from '@/api'

    export default {
        props: ['value'],
        components: {
            Nl2br
        },
        data: function(){
            return {
                profile: null,
            }
        },
        computed: {
            ...mapGetters({
                selectedBot: 'selectedBot',
            }),
            order: function(){
                return this.value
            }
        },
        mounted: function () {
            let vm = this
            document.addEventListener("keydown", (e) => {
                if (e.keyCode == 27) {
                    vm.$emit('close')
                }
            });

            vm.getShopProfile()
        },
        methods: {

            getShopProfile: function(){
                let vm = this
                if (!vm.selectedBot.pageid || vm.selectedBot.pageid == null) {
                        return false;
                    }
                    let data = {
                        pageid : vm.selectedBot.pageid
                    }
                    let auth = null
                    api.getShopProfile(data,function(error, response){
                        if (error) {
                            console.error(error)
                            
                            return
                        }
                        // console.log(response)
                        if (response.shopprofile) {
                            vm.profile = response.shopprofile
                        }
                    }) 
            },
            printCover: function(){
                
                var printSection = $("#printSection");
                if (printSection.length == 0) {
                    var printSection = document.createElement("div");
                    printSection.id = "printSection"
                    $('body').append(printSection)
                } else{

                    printSection.empty();
                }
                $('#printable').clone(true).appendTo("#printSection");
                window.print()
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/template/ecommerce/PrintCover.vue